import {AxiosResponse} from "axios";
import {GridPaginationModel} from "@mui/x-data-grid";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TEMPLATES_QUERY_KEY} from "../queryKeys";
import {ReachTemplatesFilters, ReachTemplatesPage} from "./types";

type Variables = {
  paginationModel: GridPaginationModel;
  filters: ReachTemplatesFilters;
};

const getTemplates = async (variables: Variables): Promise<ReachTemplatesPage> => {
  const page = variables.paginationModel.page + 1;
  const size = variables.paginationModel.pageSize;
  const {segmentIds, segmentMatchMode, includeUnassignedSegments, contentChannels, statuses, types, search} =
    variables.filters;
  const response = await axiosReachInstance.get<ReachTemplatesPage, AxiosResponse<ReachTemplatesPage>>("/templates", {
    params: {
      page,
      size,
      segment_ids: segmentIds,
      segment_match_mode: segmentMatchMode,
      include_unassigned_segments: includeUnassignedSegments,
      content_channel: contentChannels,
      status: statuses,
      type: types,
      search,
    },
    paramsSerializer: {indexes: null},
  });
  return response.data;
};

export const useGetTemplates = (
  variables: Variables,
  options?: BaseQueryOptions<ReachTemplatesPage, Variables>
): BaseUseQueryResult<ReachTemplatesPage> => {
  const paramsKey = JSON.stringify(variables);
  return useBaseQuery<ReachTemplatesPage, Variables>([TEMPLATES_QUERY_KEY, paramsKey], getTemplates, variables, options);
};
